import { IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { QUOTATION_QUERY } from '../../../api/queries/quotations/quotation';
import { FlattenedItem } from '../../shared/dnd/types';
import { QuantityInput } from '../list/fields/item';
import AddArrowWrapper from '../list/row/details/AddArrowWrapper';
import { getSubTotalRowStyles } from './utils';

interface Props {
  item: FlattenedItem,
  index: number,
  array: FlattenedItem[],
  arrowNestingLevel: number,
}

export default function GroupNetSalesPricePerPieceIncludingDiscount(props: Props) {
  const { item, index, array, arrowNestingLevel } = props;
  const { t } = useTranslation();
  const { quotationId } = useParams();

  return (
    <div className='flex w-full h-full'>
      <AddArrowWrapper nestingLevel={arrowNestingLevel}>
        <div className={getSubTotalRowStyles(index, array)}>
          <div>
            <div className='flex font-bold gap-x-1'>
              <span>{t('Net Sales Price/Piece including discount')}</span>
            </div>
            <div>
              <span className='text-cgray-400'>
                {item.group?.groupComputation?.netSalesPricePieceIncludingDiscountLabel}
              </span>
            </div>
          </div>
          <div className='h-full flex items-center justify-between gap-2'>
            <IconX className='w-4' />
            <div className="max-w-[100px] h-full ">
              <QuantityInput 
                refetchQueries={[{
                  query: QUOTATION_QUERY,
                  variables: {
                    quotation: quotationId as string,
                  },
                }]}
                quantity={item.quantity}
                id={item.id}
                label
              />
            </div>
          </div>
        </div>
      </AddArrowWrapper>
    </div>
  );
}
